var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLegengDespense(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0959 1.51726C18.9471 0.479202 17.4849 -0.0917324 15.9705 0.0120739C14.4038 0.063977 12.9939 0.738718 12.0017 1.88059L2.39298 12.4169C1.34856 13.5588 0.826344 15.0121 0.878565 16.5173C0.930787 18.0225 1.60966 19.4757 2.75853 20.4619C3.80295 21.4481 5.1607 21.9671 6.57067 21.9671C6.67511 21.9671 6.77955 21.9671 6.884 21.9671C8.39841 21.8633 9.80838 21.2404 10.8528 20.0986L20.4093 9.56225C21.4537 8.42038 21.9759 6.96709 21.9237 5.41C21.9237 3.90481 21.2448 2.50342 20.0959 1.51726ZM14.7172 12.8321L9.28617 7.95325L13.5683 3.23007C14.2472 2.50342 15.1349 2.0882 16.0749 2.0363C16.1271 2.0363 16.1794 2.0363 16.2316 2.0363C17.1193 2.0363 18.0071 2.39962 18.686 3.02245C19.4171 3.6972 19.8348 4.57955 19.8871 5.5138C19.9393 6.49996 19.5737 7.43422 18.8949 8.16086L14.7172 12.8321Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegengDespense);
export default __webpack_public_path__ + "static/media/legeng-despense.0a0d759b0ac368f657bedaa239331321.svg";
export { ForwardRef as ReactComponent };